<template>
  <div>
    <div class="animated bounceIn">
      <div class="btnWrapper">
        <div class="btnContainer shadow">
          <span class="removeDoneBtn" @click="this.clearDone">Clear Done</span>
        </div>

        <div class="infoBtnContainer shadow">
          <router-link to="/vuejs_todolist" v-if="!showInfo">
            <span class="far fa-question-circle infoBtn" @click="showInfo = !showInfo; sort();"></span>
          </router-link>
          <router-link to="/info" v-if="showInfo">
            <span class="far fa-question-circle infoBtn" @click="showInfo = !showInfo; sort();"></span>
          </router-link>
        </div>

        <div class="btnContainer shadow">
          <span class="clearAllBtn" @click="this.clearAll">Clear All</span>
        </div>
      </div>
    </div>
  
    <transition name="router-aim" enter-active-class="animated bounceIn" leave-active-class="animated bounceOut">
      <router-view></router-view>
    </transition>
  </div>

</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {

  data() {
      return {
          showInfo : false
      }
  },
  computed: { 
    ...mapGetters(['storedTodoItems'])
  },
  methods:{
    ...mapMutations(['clearAll', 'clearDone', 'sort']),
    
  }
}
</script>

<style scoped>
  .btnWrapper {
    display: grid;
    grid-template-columns : repeat(3, auto);
  }

  .btnContainer {
    width: 8.5rem;
    height: 50px;
    line-height: 50px;
    background-color: white;
    border-radius: 5px;
    margin: 0 auto 0.5rem;
  }

  .infoBtnContainer {
    width: 3.5rem;
    height: 50px;
    line-height: 50px;
    background-color: white;
    border-radius: 5px;
    margin: 0 auto 0.5rem;
  }

  .infoBtn {
    font-size: 1.25rem;
  }

  .clearAllBtn {
    color : #e20303;
    display : black;
  }

  .removeDoneBtn {
    color : #41a233;
    display : black;
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoFooter.vue